const ENV = process.env.ENV_NAME || "development";

const config = {
  development: {
    PRE_ENROLLMENT_URL: process.env.QA_PRE_ENROLLMENT_URL,
    RMS_PRE_ENROLLMENT_BASE_URL: process.env.QA_PRE_ENROLLMENT_BASE_URL,
    VIN_CRM_API_BASE_URL: process.env.UAT_VINE_CRM_API_BASE_URL,
    PAYMENT_GATEWAY: process.env.QA_PAYMENT_BASE_URL,
    RMS_CALL_BACK_PAYMENT_BASE_URL:
      process.env.QA_RMS_CALL_BACK_PAYMENT_BASE_URL,
    APPLY_PORTAL: process.env.APPLY_PORTAL,
  },
  release: {
    PRE_ENROLLMENT_URL: process.env.UAT_PRE_ENROLLMENT_URL,
    RMS_PRE_ENROLLMENT_BASE_URL: process.env.UAT_PRE_ENROLLMENT_BASE_URL,
    VIN_CRM_API_BASE_URL: process.env.UAT_VINE_CRM_API_BASE_URL,
    PAYMENT_GATEWAY: process.env.QA_PAYMENT_BASE_URL,
    RMS_CALL_BACK_PAYMENT_BASE_URL:
      process.env.QA_RMS_CALL_BACK_PAYMENT_BASE_URL,
    APPLY_PORTAL: process.env.APPLY_PORTAL,
  },
  production: {
    PRE_ENROLLMENT_URL: process.env.PROD_PRE_ENROLLMENT_URL,
    RMS_PRE_ENROLLMENT_BASE_URL: process.env.PROD_PRE_ENROLLMENT_BASE_URL,
    VIN_CRM_API_BASE_URL: process.env.VIN_CRM_API_BASE_URL,
    PAYMENT_GATEWAY: process.env.PROD_PAYMENT_BASE_URL,
    RMS_CALL_BACK_PAYMENT_BASE_URL:
      process.env.PROD_RMS_CALL_BACK_PAYMENT_BASE_URL,
    APPLY_PORTAL: process.env.APPLY_PORTAL,
  },
};

export const RMS_PRE_ENROLLMENT_BASE_URL =
  config[ENV].RMS_PRE_ENROLLMENT_BASE_URL;
export const VIN_CRM_API_BASE_URL = config[ENV].VIN_CRM_API_BASE_URL;
export const PRE_ENROLLMENT_URL = config[ENV].PRE_ENROLLMENT_URL;
export const PAYMENT_GATEWAY = config[ENV].PAYMENT_GATEWAY;
export const RMS_CALL_BACK_PAYMENT_BASE_URL =
  config[ENV].RMS_CALL_BACK_PAYMENT_BASE_URL;
export const APPLY_PORTAL = config[ENV].APPLY_PORTAL;
